module.exports = __webpack_public_path__ + "img/car-33.9fc498e0.jpg";